module.exports = __webpack_public_path__ + "static/media/vote01.b994ec7e.jpg";